import { RootState } from 'context';
import { AppState } from 'interfaces/app';
import React from 'react'
import { useSelector } from 'react-redux';

export const Header: React.FC = () => {

    const { isMobile } = useSelector<RootState, AppState>((state) => state.app)

    return (
        <div className={ `${isMobile && 'bp-p-16'}`}>
            <pichincha-typography align='center' variant="h3" color='blue' weight_color='500'>
                ¿Cuánto dinero necesitas?
            </pichincha-typography>
        </div>
    );
}
